// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

export default (n) => {
    if (n > 999999999)
        return String(Math.floor(n/100000000)/10) + "B";

    if (n > 999999)
        return String(Math.floor(n/100000)/10) + "M";

    if (n > 999)
        return String(Math.floor(n/100)/10) + "k";

    return String(n);
}